/**
 * ============================================================
 * UNMAPPED — Global Configuration
 * ============================================================
 * Replace GOOGLE_FORM_URL with your actual Google Form link.
 * This is the only place you need to update it.
 */
export const GOOGLE_FORM_URL = 'https://forms.gle/kGxPK5p31dNyTjxM7';

export const BRAND_NAME = 'Unmapped';
export const TOTAL_SPOTS = 50;
export const SPOTS_CLAIMED = 23; // update as spots fill up

export const CTA_MICROCOPY = "You'll be redirected to a quick early-access form.";
